/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Master Digital Pharma Notification Template API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { NotificationTemplateCreateRestDto } from '../models';
import { NotificationTemplateRestDto } from '../models';
import { NotificationTemplateResultsRestDto } from '../models';
/**
 * NotificationTemplateAPIApi - axios parameter creator
 * @export
 */
export const NotificationTemplateAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint responsible for creating a new notification template.
         * @summary REST.API.NT.02 Create a notification template.
         * @param {NotificationTemplateCreateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationTemplate: async (body: NotificationTemplateCreateRestDto, x_dp_module_code: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createNotificationTemplate.');
            }
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling createNotificationTemplate.');
            }
            const localVarPath = `/notification_template/v1/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.NT.01 Find notification templates.
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplates: async (x_dp_module_code: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling getNotificationTemplates.');
            }
            const localVarPath = `/notification_template/v1/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint responsible for creating a new notification template.
         * @summary REST.API.NT.03 Update a notification template.
         * @param {NotificationTemplateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} id Uniquely identifies a Notification Template.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate: async (body: NotificationTemplateRestDto, x_dp_module_code: string, id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateNotificationTemplate.');
            }
            // verify required parameter 'x_dp_module_code' is not null or undefined
            if (x_dp_module_code === null || x_dp_module_code === undefined) {
                throw new RequiredError('x_dp_module_code','Required parameter x_dp_module_code was null or undefined when calling updateNotificationTemplate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateNotificationTemplate.');
            }
            const localVarPath = `/notification_template/v1/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationTemplateAPIApi - functional programming interface
 * @export
 */
export const NotificationTemplateAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * API endpoint responsible for creating a new notification template.
         * @summary REST.API.NT.02 Create a notification template.
         * @param {NotificationTemplateCreateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotificationTemplate(_axios: AxiosInstance, body: NotificationTemplateCreateRestDto, x_dp_module_code: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NotificationTemplateAPIApiAxiosParamCreator(configuration).createNotificationTemplate(body, x_dp_module_code, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.NT.01 Find notification templates.
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationTemplates(_axios: AxiosInstance, x_dp_module_code: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateResultsRestDto>> {
            const localVarAxiosArgs = await NotificationTemplateAPIApiAxiosParamCreator(configuration).getNotificationTemplates(x_dp_module_code, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API endpoint responsible for creating a new notification template.
         * @summary REST.API.NT.03 Update a notification template.
         * @param {NotificationTemplateRestDto} body 
         * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
         * @param {string} id Uniquely identifies a Notification Template.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationTemplate(_axios: AxiosInstance, body: NotificationTemplateRestDto, x_dp_module_code: string, id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NotificationTemplateAPIApiAxiosParamCreator(configuration).updateNotificationTemplate(body, x_dp_module_code, id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationTemplateAPIApi - object-oriented interface
 * @export
 * @class NotificationTemplateAPIApi
 * @extends {BaseAPI}
 */
export class NotificationTemplateAPIApi extends BaseAPI {
    /**
     * API endpoint responsible for creating a new notification template.
     * @summary REST.API.NT.02 Create a notification template.
     * @param {NotificationTemplateCreateRestDto} body 
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateAPIApi
     */
     public createNotificationTemplate(body: NotificationTemplateCreateRestDto, x_dp_module_code: string, x_dp_customer_code?: string|null, options?: any) {
        return NotificationTemplateAPIApiFp(this.configuration).createNotificationTemplate(this.axios, body, x_dp_module_code, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.NT.01 Find notification templates.
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateAPIApi
     */
     public getNotificationTemplates(x_dp_module_code: string, x_dp_customer_code?: string|null, options?: any) {
        return NotificationTemplateAPIApiFp(this.configuration).getNotificationTemplates(this.axios, x_dp_module_code, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint responsible for creating a new notification template.
     * @summary REST.API.NT.03 Update a notification template.
     * @param {NotificationTemplateRestDto} body 
     * @param {string} x_dp_module_code The unique identification of the Digital-Pharma module.
     * @param {string} id Uniquely identifies a Notification Template.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateAPIApi
     */
     public updateNotificationTemplate(body: NotificationTemplateRestDto, x_dp_module_code: string, id: string, x_dp_customer_code?: string|null, options?: any) {
        return NotificationTemplateAPIApiFp(this.configuration).updateNotificationTemplate(this.axios, body, x_dp_module_code, id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
